import styled from '@emotion/styled'
import theme from '@utils/theme'

export const outlineButton = `
  background: transparent;
  border: 1px solid ${theme.colors.primary};
  color: ${theme.colors.primary};
`

// Styled components
export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`

export const FieldGroup = styled.div`
  flex: 2;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 15px;

  & > div {
    width: 100%;
  }
`

export const UploadWrapper = styled.div`
  flex: 1;
  min-width: 200px;

  & > div {
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
